import React from 'react';
import type { ReactNode } from 'react';

import isNil from '../../../../utils/isNil';
import { useSelectRootContext } from '../root/SelectRootContext';
import { useSelectedOption } from '../root/useSelectedOption';

import styles from './SelectValue.module.scss';

export const useSelectValueNode = (): ReactNode => {
    const {
        value,
        mode,
        autoComplete,
        internalSearchValue,
        isAutoCompleteControlled,
        showSearch,
        isInlineInputSearchVisible
    } = useSelectRootContext();
    const selected = useSelectedOption();

    if (autoComplete) {
        if (value === undefined || value === null || value === '') return null;
        return !isAutoCompleteControlled ? (
            <span className={styles.visuallyHidden}>{value}</span>
        ) : (
            // The value already appears in the input,
            // so this serves as a placeholder as the input
            // doesn't fill any space in the layout.
            <div />
        );
    }

    if (mode === 'multiple') return null;

    if (mode === 'single') {
        if (!isNil(selected.option) && internalSearchValue === '') {
            return <div className={styles.selectedOption}>{selected.renderer()}</div>;
        }
        if (
            isNil(selected.option) &&
            internalSearchValue === '' &&
            showSearch &&
            isInlineInputSearchVisible &&
            value
        ) {
            return <div className={styles.selectedOption}>{value}</div>;
        }
        if (isNil(selected.option) && internalSearchValue === '') {
            return value;
        }
    }

    return null;
};
